import { render, staticRenderFns } from "./LogoLogin.vue?vue&type=template&id=667dff5b&"
import script from "./LogoLogin.vue?vue&type=script&lang=js&"
export * from "./LogoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports